var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLmtViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1998_24682)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1998_24682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.222 6.59883C12.7407 3.47852 10.5017 1.9082 7.50009 1.9082C4.49697 1.9082 2.25947 3.47852 0.778215 6.60039C0.718802 6.7262 0.687988 6.8636 0.687988 7.00273C0.687988 7.14187 0.718802 7.27927 0.778215 7.40508C2.25947 10.5254 4.49853 12.0957 7.50009 12.0957C10.5032 12.0957 12.7407 10.5254 14.222 7.40352C14.3423 7.15039 14.3423 6.85664 14.222 6.59883ZM7.50009 10.9707C4.97978 10.9707 3.13447 9.69258 1.8329 7.00195C3.13447 4.31133 4.97978 3.0332 7.50009 3.0332C10.0204 3.0332 11.8657 4.31133 13.1673 7.00195C11.8673 9.69258 10.022 10.9707 7.50009 10.9707ZM7.43759 4.25195C5.91884 4.25195 4.68759 5.4832 4.68759 7.00195C4.68759 8.5207 5.91884 9.75195 7.43759 9.75195C8.95634 9.75195 10.1876 8.5207 10.1876 7.00195C10.1876 5.4832 8.95634 4.25195 7.43759 4.25195ZM7.43759 8.75195C6.4704 8.75195 5.68759 7.96914 5.68759 7.00195C5.68759 6.03477 6.4704 5.25195 7.43759 5.25195C8.40478 5.25195 9.18759 6.03477 9.18759 7.00195C9.18759 7.96914 8.40478 8.75195 7.43759 8.75195Z",
    fill: "black",
    fillOpacity: 0.45
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1998_24682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1998_24682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLmtViewIcon);
export default __webpack_public_path__ + "static/media/lmt-view-icon.c019a9dc84b84be5f50b58067964aded.svg";
export { ForwardRef as ReactComponent };